import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { SharedService } from '../../../shared/services/shared.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { API_URLS } from '../../../shared/constants/api-urls.constants';

export interface WorkHistory {
    workHistoryId: string;
    organizationName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    startDate: string;
    endDate: string;
    hasGaps?: boolean;
    gapExplanation?: string;
    IsLocationInDW?: boolean;
    other?: string;
    isCurrentlyWorking?:any;
}

// @Injectable({
//     providedIn: 'root'
// })
// export class WorkHistoryService {
//     private workHistoriesSubject = new BehaviorSubject<WorkHistory[]>([]);
//     public workHistories$: Observable<WorkHistory[]> = this.workHistoriesSubject.asObservable();

//     constructor() { }

//     getWorkHistories(): WorkHistory[] {
//         return this.workHistoriesSubject.value;
//     }

//     addWorkHistory(history: WorkHistory): void {
//         const currentHistories = this.workHistoriesSubject.value;
//         if (currentHistories.length < 5) {
//             this.workHistoriesSubject.next([...currentHistories, history]);
//         }
//     }

//     updateWorkHistory(id: string, history: WorkHistory): void {
//         const currentHistories = this.workHistoriesSubject.value;
//         const index = currentHistories.findIndex(h => h.id === id);
//         if (index !== -1) {
//             currentHistories[index] = history;
//             this.workHistoriesSubject.next([...currentHistories]);
//         }
//     }

//     deleteWorkHistory(id: string): void {
//         const currentHistories = this.workHistoriesSubject.value;
//         this.workHistoriesSubject.next(currentHistories.filter(h => h.id !== id));
//     }

//     canAddMore(): boolean {
//         return this.workHistoriesSubject.value.length < 5;
//     }

//     generateId(): string {
//         return Date.now().toString() + Math.random().toString(36).substr(2, 9);
//     }
// }

@Injectable({ providedIn: 'root' })
export class WorkHistoryService {

  private storageKey = 'workhistories';

  private workHistoriesSubject = new BehaviorSubject<WorkHistory[]>(this.loadFromStorage());
  public workHistories$ = this.workHistoriesSubject.asObservable();

  constructor(private sharedService: SharedService, private http:HttpClient) {}

  // -------------------------------
  // Load from localStorage (API preload)
  // -------------------------------
  private loadFromStorage(): WorkHistory[] {
    const credentialingId = localStorage.getItem('credentialingEventId');
    const userId = Number(localStorage.getItem('user_id'));
    const raw = localStorage.getItem(this.storageKey);
    if (!raw) return [];

    const apiRows = JSON.parse(raw);
    return apiRows.map((r: any) => ({
     // id: r.workHistoryId || this.generateId(),
      workHistoryId: r.workHistoryId,
      credentialingEventId: credentialingId,
      userId: userId,
      organizationName: r.organizationName,
      address1: r.address1 || '',
      address2: r.address2 || '',
      city: r.city || '',
      state: r.state || '',
      zip: r.zip || '',
      phone: r.phone || r.phoneNumber || '',
      startDate: this.formatDate(r.startDate),
      endDate: this.formatDate(r.endDate),
     // hasGaps: !!r.gapExplanation,
      gapExplanation: r.gapExplanation || '',
      isSchool: r.isSchool || false,
      isLocationInDW: r.isLocationInDW ?? false,
      other: r.other || '',
      isCurrentlyWorking: r.isCurrentlyWorking ?? false
      
    }));
  }

  private formatDate(val: any): string {
    if (!val) return '';
    val = "" + val
    if (val.length === 8) {
      return `${val.substring(0,4)}-${val.substring(4,6)}-${val.substring(6,8)}`;
    }
    return val;
  }

  // -------------------------------
  // Core getters
  // -------------------------------
  getWorkHistories(): WorkHistory[] {
    return this.workHistoriesSubject.value;
  }

  canAddMore(): boolean {
    return this.workHistoriesSubject.value.length < 5;
  }

  generateId(): string {
    return Date.now().toString() + Math.random().toString(36).substring(2, 9);
  }

  // -------------------------------
  // Add / Update / Delete (kept)
  // -------------------------------
  addWorkHistory(history: WorkHistory): void {
    const data = [...this.workHistoriesSubject.value, history];
    this.save(data);
  }

  updateWorkHistory(id: string, history: WorkHistory): void {
    const data = this.workHistoriesSubject.value.map(h =>
      h.workHistoryId === id ? history : h
    );
    this.save(data);
  }

  deleteWorkHistory(id: string) {
     const credentialingId = localStorage.getItem('credentialingEventId');
     const userId = Number(localStorage.getItem('user_id'));
    // const data = this.workHistoriesSubject.value.filter(h => h.workHistoryId !== id);
    // this.save(data);
      const existing:any[]= JSON.parse(localStorage.getItem(this.storageKey)|| '[]');
      //const remaining = existing.filter(h => h.workHistoryId !== id).map((h:any)=>{
      const remaining = existing.map((h:any)=>{
        if(typeof(h['endDate']) == "number") {
          h.endDate = this.formatDate(""+h.endDate)
          }
        const obj = {
        phone:h.phone || h.phoneNumber || '',
        userId:userId,
        workHistoryId: h.workHistoryId,
        organizationName: h.organizationName,
        address1: h.address1 || '',
        address2: h.address2 || '',
        city: h.city || '',
        state: h.state || '',
        zip: h.zip || '',
        startDate: this.formatDate(h.startDate) || null,
        endDate: this.formatDate(h.endDate) || null,
       // hasGaps: !!rest.gapExplanation,
        gapExplanation: h.gapExplanation || '',
        isSchool: h.isSchool ?? true,
        credentialingEventId: credentialingId,
        isDeleted: h.workHistoryId == id,
        isLocationInDW: h.isLocationInDW ?? false
        }

        delete h.phoneNumber;
        return obj;
      })
     return this.sharedService.saveWorkhistory(remaining).pipe(
        tap((res: any) => {
        const normalized = (res || []).map((h:any) =>{
        const obj = {...h};
        obj.phone =obj.phone || obj.phoneNumber || '';
        obj.userId =obj.userId ?? -1;
        delete obj.phoneNumber;
        return obj;
    })
      localStorage.setItem(this.storageKey, JSON.stringify(normalized));
      this.workHistoriesSubject.next(normalized);
  }))

  }

  // -------------------------------
  // Save back to localStorage
  // -------------------------------
  private save(data: WorkHistory[]) {
    this.workHistoriesSubject.next(data);

    // keep localStorage in sync (still API-format not required here)
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  reloadFromStorage() {
    const data = this.loadFromStorage();
    this.workHistoriesSubject.next(data);
  }



saveToApi(payload: any[]) {
  const credentialingId = localStorage.getItem('credentialingEventId');
  const userId = Number(localStorage.getItem('user_id'));
  let existing:any[]= JSON.parse(localStorage.getItem(this.storageKey)|| '[]').map((h:any)=>{
    const{phoneNumber, hasGaps, ...rest} = h;
    return{
      ...rest,
        phone:h.phone || h.phoneNumber || '',
        userId:h.userId ?h.userId:userId?userId: -1,
        workHistoryId: rest.workHistoryId,
        organizationName: rest.organizationName,
        address1: rest.address1 || '',
        address2: rest.address2 || '',
        city: rest.city || '',
        state: rest.state || '',
        zip: rest.zip || '',
        startDate: this.formatDate(rest.startDate) || null,
        endDate: this.formatDate(rest.endDate) || null,
       // hasGaps: !!rest.gapExplanation,
        gapExplanation: rest.gapExplanation || '',
        isSchool: rest.isSchool ?? true,
        credentialingEventId: credentialingId,
        isLocationInDW: rest.isLocationInDW ?? false

  }
  })
  const objectToRemove = ['inactiveDate', 'createdUserID', 'createdDate', 'modifiedUserID', 'modifiedDate', 'activeFlg'];
   existing = existing.map((obj:any) =>{
   const copy = {...obj};
   objectToRemove.forEach((key)=>{
    if(key in copy){
      delete copy[key];
    }
   })
   return copy;
   })


const filteredExisting = existing.map(rest=>({
        phone:rest.phone || rest.phoneNumber || '',
        userId:rest.userId ?? -1,
        workHistoryId: rest.workHistoryId,
        organizationName: rest.organizationName,
        address1: rest.address1 || '',
        address2: rest.address2 || '',
        city: rest.city || '',
        state: rest.state || '',
        zip: rest.zip || '',
        startDate: this.formatDate(rest.startDate) || null,
        endDate: this.formatDate(rest.endDate) || null,
       // hasGaps: !!rest.gapExplanation,
        gapExplanation: rest.gapExplanation || '',
        isSchool: rest.isSchool ?? true,
        credentialingEventId: credentialingId,
        isLocationInDW: rest.isLocationInDW ?? false
}))




  const combined = [...filteredExisting, ...payload];
  const uniqueMap = new Map();
  combined.forEach(item =>
    uniqueMap.set(item.workHistoryId,{...item, workHistoryId: item.workHistoryId}
  ))
  const unique = Array.from(uniqueMap.values());
  return this.sharedService.saveWorkhistory(unique).pipe(
    tap((res: any) => {

      const normalized = (res || []).map((h:any) =>{
        const obj = {...h};
        obj.phone =obj.phone || obj.phoneNumber || '';
       // obj.userId =obj.userId ?? -1;
        delete obj.phoneNumber;
        return obj;
      })

      localStorage.setItem(this.storageKey, JSON.stringify(normalized));
      this.workHistoriesSubject.next(normalized);
    })
  );
}

getSchoolList(): Observable<any> {
  return this.http.get(`${environment.providerApiUrl}${API_URLS.GET_SCHOOLS}`)
}
sortByDate(workHistory:any){
  return workHistory.sort((a: any, b: any) => {

   if (a?.isLocationInDW && !b?.isLocationInDW) return -1;
   if (!a?.isLocationInDW && b?.isLocationInDW) return 1;
 
    const aDateStr = a?.startDate;
    const bDateStr = b?.startDate;
   
    if (!aDateStr && !bDateStr) return 0;
    if (!aDateStr) return -1;
    if (!bDateStr) return 1;
   
    const [am, ad, ay] = aDateStr.split('-').map(Number);
    const [bm, bd, by] = bDateStr.split('-').map(Number);
   
    const dateA = new Date(ay, am - 1, ad);
    const dateB = new Date(by, bm - 1, bd);
   
    return dateA.getTime() - dateB.getTime();
  });
}
}